import { VoteFailure } from 'query/study/Votes';
import { getToastConfig } from 'constants/httpErrorToasts';

const GENERIC_MESSAGE = getToastConfig(500).message;

export const voteFailureMessage = (failure: VoteFailure): string => {
  switch (failure.reason) {
    // Ignore the server message, it can be the review as JSON
    case 'unauthorized':
    case 'forbidden':
      return getToastConfig(failure.status).message;
    case 'trialLimitReached':
      return failure.serverMessage ?? 'Trial screening limit reached';
    case 'notFound':
      return 'Review has been deleted';
    case 'conflict':
    case 'invalid':
      return failure.serverMessage ?? GENERIC_MESSAGE;
    case 'network':
    case 'server':
    case 'unknown':
      return GENERIC_MESSAGE;
  }
};
